import { axiosInstance } from 'config/axios/axios.config.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationsStatus } from 'components/Header/components/Notifications/hooks';

const markNotificationRequest = async ({
  id,
  variant,
}: {
  id: string;
  variant: NotificationsStatus;
}) => {
  const response = axiosInstance.patch(`/notifications/${id}/${variant}`);
  const data = await response;

  return data;
};

export const useMarkNotificationMutation = () => {
  const client = useQueryClient();

  const mutation = useMutation({
    mutationKey: ['markNotification'],
    mutationFn: ({
      id,
      variant,
    }: {
      id: string;
      variant: NotificationsStatus;
    }) => markNotificationRequest({ id, variant }),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['notifications'] });
      client.invalidateQueries({ queryKey: ['task'] });
    },
  });

  return mutation;
};

const markAllNotificationRequest = async () => {
  const response = axiosInstance.patch(`/notifications/read-all`);
  const data = await response;

  return data;
};

export const useMarkAllNotificationMutation = () => {
  const client = useQueryClient();

  const mutation = useMutation({
    mutationKey: ['markAllNotification'],
    mutationFn: () => markAllNotificationRequest(),
    onSuccess: () => client.invalidateQueries({ queryKey: ['notifications'] }),
  });

  return mutation;
};
